import performFieldValidation from '../validation/performFieldValidation';
import clearErrorOnField from '../validation/clearErrorOnField';
var gaTracker = require('../analytics/gaTracker');

require('./trialCTA');

var recaptchaResponseValidation = require('../g-recaptcha/recaptchaResponseValidation');

const $createTicket = $('#create-ticket');
const $zenContact = $('#zen-contact');

// initial page state setup
$('.js-load-plan').addClass('hidden');
$('.js-force-yearly').addClass('hidden');

[$('#paywallwelcome'), $('#billingFailed')]
  .forEach((element) => element !== undefined && element.modal('show'));

$('.js-billing-link').on('click', () => $('#billingFailed').modal('hide'));

function setDisplayYearly (showYearlyPrices) {
  $('.js-price-yearly').toggleClass('hidden', !showYearlyPrices);
  $('.js-plan-yearly').toggleClass('hidden', !showYearlyPrices);
  $('.js-price-monthly').toggleClass('hidden', showYearlyPrices);
  $('.js-plan-monthly').toggleClass('hidden', showYearlyPrices);
  $('.js-btn-yearly').toggleClass('hidden', !showYearlyPrices);
  $('.js-your-plan').toggleClass('hidden', showYearlyPrices);
}

// switch between yearly monthly pricing
$('.js-switch-yearly').on('click', function () {
  setDisplayYearly(true);
});

$('.js-switch-monthly').on('click', function () {
  setDisplayYearly(false);
});

// skip paywall button
$('.js-skip').on('click', function (event) {
  event.preventDefault();
  $('form.js-skip-paywall').submit();
});

// create a trial subscription
$('.js-trial').on('click', function (event) {
  event.preventDefault();
  const url = $(this).attr('href');
  const planCode = $(this).data('trial-plan');
  $(this).find('.js-load-plan').removeClass('hidden');

  $.post(url, { plan: planCode })
    .done(data => {
      window.location.href = data.location;
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      window.Raven.captureMessage('Ajax plan change failed', {
        extra: {
          textStatus: textStatus,
          errorThrown: errorThrown,
          url: url,
          plan: planCode
        }
      });
    });
});

$('.js-updowngrade .js-choose-plan').on('click', function (event) {
  event.preventDefault();
  const chosenLink = $(this).attr('href');
  const changePlanLink = $('.js-confirm-plan');
  const priceText = $(this).parents('.js-price-box').find('.js-price:visible').text();
  changePlanLink.attr('href', chosenLink);

  $('#confirm-plan-change .price').text(priceText);
  $('#confirm-plan-change').modal();
});

$createTicket.find('input').on('blur', function () {
  return performFieldValidation($(this));
});

$createTicket.find('input').on('focus', function () {
  return clearErrorOnField($(this));
});

// create ticket in recurly
$createTicket.on('submit', function (event) {
  event.preventDefault();

  const $this = $(this);

  $('.js-submit-ticket').addClass('busy');

  if (performFieldValidation($this.find('input'))) {
    recaptchaResponseValidation(window['js-grecaptcha-callback-pricing-modal']);

    const url = $createTicket.attr('action');
    const data = $createTicket.serializeArray();
    $.post(url, data)
      .done(data => {
        $('.js-submit-ticket').removeClass('busy');
        $('.js-contact-success').removeClass('hidden');
        gaTracker('pricing-enterprise-contact-submit');
        resetForm();
        $zenContact.modal('hide');
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        window.Raven.captureMessage('Zendesk ticket creation error', {
          extra: {
            textStatus: textStatus,
            errorThrown: errorThrown,
            url: url,
            data: data
          }
        });
      });
  } else {
    $('.js-submit-ticket').removeClass('busy');
  }
});

function resetForm () {
  try {
    $createTicket[0].reset();
    window.grecaptcha.reset(window['js-grecaptcha-callback-pricing-modal']);
    $createTicket.find('.form-group').removeClass('error has-error');
  } catch (errorThrown) {
    window.Raven.captureMessage('Zendesk ticket form reset error', {
      extra: {
        errorThrown: errorThrown
      }
    });
  }
}
